import React from "react";

// Turns bare URLs, emails and AU phone numbers in plain text into tappable links. Safe: renders text nodes, never HTML.
const PATTERN = /((?:https?:\/\/|www\.)[^\s<>"')\]]+[^\s<>"')\].,;:!?])|([\w.+-]+@[\w-]+\.[\w.-]+\w)|((?:\+61\s?|\(?0)[2-9]\)?[\s-]?\d{1,4}[\s-]?\d{3,4}[\s-]?\d{0,4})/g;

const telHref = (p) => { let d = p.replace(/\D/g, ""); if (d.startsWith("0")) d = "61" + d.slice(1); return `tel:+${d}`; };

export const Linkify = ({ text, className }) => {
  if (!text) return null;
  const out = [];
  let last = 0, m, i = 0;
  PATTERN.lastIndex = 0;
  while ((m = PATTERN.exec(text)) !== null) {
    if (m.index > last) out.push(text.slice(last, m.index));
    const [full, url, email, phone] = m;
    const digits = full.replace(/\D/g, "");
    if (url) out.push(<a key={i++} href={url.startsWith("http") ? url : `https://${url}`} target="_blank" rel="noreferrer" className="text-primary underline underline-offset-2 break-all" data-testid="linkified-url">{url}</a>);
    else if (email) out.push(<a key={i++} href={`mailto:${email}`} className="text-primary underline underline-offset-2 break-all" data-testid="linkified-email">{email}</a>);
    else if (phone && digits.length >= 8 && digits.length <= 12) out.push(<a key={i++} href={telHref(phone)} className="text-primary underline underline-offset-2 whitespace-nowrap" data-testid="linkified-phone">{phone}</a>);
    else out.push(full);
    last = m.index + full.length;
  }
  if (last < text.length) out.push(text.slice(last));
  return <span className={className}>{out}</span>;
};
